module.exports = __webpack_public_path__ + "img/pic10.6691b46e.png";